/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  crmRouterSegment,
  customerProfileRouterSegment,
  customerRouterSegment,
  newCustomerRouterSegment
} from './crm-navigation-constants';

export const customerSmallProfileUrl = (customerUuid: any) => ['/', {outlets: {popup: ['popup', crmRouterSegment, 's', customerRouterSegment, customerProfileRouterSegment, customerUuid]}}]
export const addCustomerUrl = [
  '/',
  {
    outlets: {
      'popup-full': ['popup-full', crmRouterSegment, 's', customerRouterSegment, newCustomerRouterSegment],
    },
  }
]
